







































































import { Vue, Component } from 'vue-property-decorator';
import AppBase from '../common/base';

@Component
export default class Survey extends AppBase {

    data: any = {};
    survey: any = null;
    itemsSections: any[] = null;
    itemIndex: number = 0;
    transitionName = 'fade';

    async created() {
        let data = await this.$store.dispatch('loadSurvey', { slug: this.$route.params.slug });
        if (data) {
            this.survey = data.survey;
            this.itemsSections = [];
            for (var section of data.sections) {
                if (section.items) {
                    for (var item of section.items) {
                        this.itemsSections.push({ item, section });
                    }
                }
            }
            if (data.results && data.results.length > 0 && data.results[0].data) {
                for (let k in data.results[0].data) {
                    this.data[k] = data.results[0].data[k][k];
                }
            }
            else {
                for (let is of this.itemsSections) {
                    this.data[is.item.key] = parseFloat(is.item.defaultValue);
                }
            }
        }

        this.updateTheme();
    }

    private updateTheme() {
        let slide = this.itemsSections[this.itemIndex].item;
        let theme = {
            theme: 'survey',
            'slide-index': this.itemIndex.toString()
        };
        if (slide.themeParameters && slide.themeParameters.CssClassNames) {
            theme['slide'] = slide.themeParameters.CssClassNames;
        }
        this.$store.commit('setTheme', theme);
    }

    get slug() {
        return this.$route.params.slug;
    }

    get slideClasses() {
        let classes = ['survey-item'];
        switch (this.slideLayout) {
            case 'image':
                classes.push('image-layout');
                break;
            default:
                classes.push('default-layout');
                break;
        }
        let theme = this.$store.state.theme;
        if (theme) {
            for (let k in theme) {
                classes.push(`${k}-${theme[k]}`);
            }
        }
        return classes;
    }

    get slideLayout() {
        return this.itemsSections[this.itemIndex].item.layout || 'default';
    }

    get slideHasImage() {
        let slide = this.itemsSections[this.itemIndex].item;
        return slide.themeParameters && slide.themeParameters.ImageName;
    }

    get itemOptions() {
        return this.itemsSections[this.itemIndex].item.options;
    }

    get showPrev() {
        return true;
    }

    get showNext() {
        if (this.itemsSections) {
            let item = this.itemsSections[this.itemIndex].item;
            let data = this.data[item.key];
            return (!data || data == item.defaultValue) && this.itemIndex < this.itemsSections.length - 1;
        }

        return false;
    }

    isItemVisible(item: any) {
        return this.itemsSections.indexOf(item) == this.itemIndex;
    }

    onOptionChange() {
        this.onNext();
    }

    onOptionClick(evt: Event) {
        let label = evt.target;
        if (label instanceof HTMLLabelElement) {
            let input = label.parentElement.querySelector('input') as HTMLInputElement;
            if (input.value == this.data[input.id.split('__')[0]]) {
                this.onNext();
            }
        }
    }

    onPrev() {
        if (this.itemIndex == 0) {
            this.$router.push({ name: 'survey-chooser', params: { slug: this.slug }});
        }
        else {
            this.move(-1);
        }
    }

    onNext() {
        if (this.itemIndex == this.itemsSections.length - 1) {
            this.saveResults(true);
            this.$router.push({ name: 'results', params: { slug: this.slug }});
        }
        else {
            this.move(1);
        }
    }

    private move(direction: number) {
        // Only the first transition is fade. After mount we slide left or right.
        this.transitionName = direction == -1 ? 'slide-right' : 'slide-left';
        if (this.itemsSections) {
            this.itemIndex += direction;
            this.updateTheme();
            if (direction == 1) {
                this.saveResults(false);
            }
        }
    }

    private async saveResults(isComplete) {
        let result = { isComplete, data: {}};
        for (let k in this.data) {
            result.data[k] = { [k]: parseFloat(this.data[k]) };
        }
        await this.$store.dispatch('updateSurveyResult', { slug: this.slug, result });
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/surveys/survey.vue